import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMoveFolder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"move-folder"} maskId="square-filled-radius-0-stroke-1-IconMoveFolder"><path d="M23.207 17.5L19.8535 20.8535L19.1465 20.1465L21.293 18H15V17H21.293L19.1465 14.8535L19.8535 14.1465L23.207 17.5Z" fill="currentColor"/><path d="M12.2676 6H22V14.8789L19.8535 12.7324L17.7324 14.8535L18.8789 16H14V19H18.8789L17.8789 20H2V3H10.2676L12.2676 6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMoveFolder;
